<template>
	<div class="content background2">
		<div class="searchBox">
			<div class="searchBox-list">
				<div class="searchBox-black">
					<label class="searchBox-label">客户名称</label>
					<div class="searchBox-condition">
						<el-input class="input-class" v-model="searchParam.customerName" placeholder="请输入客户名称">
						</el-input>
					</div>
				</div>
				<div class="searchBox-black">
					<label class="searchBox-label">客户类型</label>
					<div class="searchBox-condition" style="width: 150px">
						<el-select class="select-class" v-model="searchParam.customerType" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="(item, index) in customerTypeList" :label="item.name" :value="item.id"
								:key="index">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="searchBox-black">
					<label class="searchBox-label">维护开始时间</label>
					<div class="searchBox-condition">
						<el-date-picker class="date-class" v-model="searchParam.begintime" value-format="yyyy-MM-dd"
							type="date" placeholder="开始日期">
						</el-date-picker>
					</div>
				</div>
				<div class="searchBox-black">
					<label class="searchBox-label">至</label>
					<div class="searchBox-condition">
						<el-date-picker class="date-class" v-model="searchParam.begintime2" value-format="yyyy-MM-dd"
							type="date" placeholder="结束日期">
						</el-date-picker>
					</div>
				</div>
				<div class="searchBox-black">
					<label class="searchBox-label">维护状态</label>
					<div class="searchBox-condition" style="width: 150px">
						<el-select class="select-class" v-model="searchParam.state" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="(item, index) in stateList" :label="item.name" :value="item.id"
								:key="index">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="searchBox-black">
					<label class="searchBox-label">维护类型</label>
					<div class="searchBox-condition" style="width: 150px">
						<el-select class="select-class" v-model="searchParam.contentTitle" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="(item, index) in typeList" :label="item.name" :value="item.name"
								:key="index">
							</el-option>
						</el-select>
					</div>
				</div>
				<!-- <div class="searchBox-black">
					<label class="searchBox-label">维护内容</label>
					<div class="searchBox-condition" style="width: 150px">
						<el-select class="select-class" v-model="searchParam.contentDescribe" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="(item, index) in contentList" :label="item.name" :value="item.name"
								:key="index">
							</el-option>
						</el-select>
					</div>
				</div> -->
				<div class="searchButton" @click="search({ pageNo: 1, pageSize: pageSize })">
					查询
				</div>
			</div>
		</div>
		<div class="tableList">
			<div style="
          position: relative;
          width: 100%;
          height: 100%;
          background-color: #fff;
        ">
				<div class="tableTitle" style="position: relative; z-index: 11">
					<p class="title">详细内容</p>
					<excel-export :filename="utils.getNowFormatDate() + '维护列表'" :sheet="sheet"
						class="exportButtonWrapper">
						<div class="exportButton" v-if="menuList.indexOf('CD_310') != -1">
							导出
						</div>
					</excel-export>
					<div class="exportButtonWrapper">
						<button class="alarm-list-btn-1" style="width: 100px; font-size: 16px;" @click="showDetails">查看详细</button>
					</div>
				</div>
			</div>
			<div class="list" style="z-index: 10; padding-top: 180px">
				<div class="list-content">
					<div ref="multipleTable" class="list-table-block">
						<el-table class="black-table" :data="tableData" :height="height" tooltip-effect="dark"
							style="width: 100%" @current-change="handleCurrentChange">
							<el-table-column type="index" header-align="center" align="center" :index="getIndex"
								label="序号" width="60">
							</el-table-column>
							<el-table-column prop="customerName" label="客户名称" width="120"></el-table-column>
							<el-table-column width="320" prop="address" label="所在区域地址"></el-table-column>
							<el-table-column width="120" prop="deviceId" label="设备号"></el-table-column>
							<el-table-column prop="planDateBegin" label="维护开始时间" width="150" show-overflow-tooltip>
								<template slot-scope="scope">
									{{ scope.row.planDateBegin.split(" ")[0] }}
								</template>
							</el-table-column>
							<el-table-column prop="completionTime" label="完成时间" width="120" show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="supportPerson" label="人员" show-overflow-tooltip></el-table-column>
							<el-table-column prop="contentTitle" label="维护类型" show-overflow-tooltip></el-table-column>
							<!-- <el-table-column prop="contentDescribe" label="维护内容"   show-overflow-tooltip>
							</el-table-column> -->
							<el-table-column prop="state" label="维护状态" show-overflow-tooltip>
								<template slot-scope="scope">
									<template v-for="item in stateList"
										v-if="scope.row.state == item.id">{{ item.name }}</template>
								</template>
							</el-table-column>
							<el-table-column prop="" label="未及时维护" show-overflow-tooltip>
								<template slot-scope="scope">
									{{
                    getTimeSection(
                      scope.row.receiveTime,
                      scope.row.completionTime
                    )
                  }}
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<div ref="page" class="page">
			<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="search"></Page>
		</div>
		<div class="drawer" v-show="details">
			<div>
				<div class="drawer-title">
					<div class="drawer-label">详细</div>
					<div class="drawer-btn" @click="details = false">×</div>
				</div>
				<div class="customer-title">
					<div class="customer-title-label">{{ detail.customerName }}</div>
				</div>
				<div class="alarm-customer-info">
					<ul class="customer-info-param">
						<li>
							<div class="info-title">客户地址</div>
							<div class="info-param">
								{{ detail.province }}{{ detail.city }}{{ detail.district
				}}{{ detail.town }}{{ detail.address }}
							</div>
						</li>
						<li>
							<div class="info-title">设备号</div>
							<div class="info-param">{{detail.deviceId}}</div>
						</li>
						<li>
							<div class="info-title">维护开始时间</div>
							<div class="info-param">{{detail.planDateBegin}}</div>
						</li>
						<li>
							<div class="info-title">完成时间</div>
							<div class="info-param">{{detail.completionTime}}</div>
						</li>
						<li>
							<div class="info-title">维护类型</div>
							<div class="info-param">{{detail.contentTitle}}</div>
						</li>

						<li>
							<div class="info-title">维护状态</div>
							<div class="info-param">{{detail.state}}</div>
						</li>
						<li>
							<div class="info-title">现场照片</div>
							<div class="info-param">
								<span v-for="(item, index) in detail.workPics" :key="index">
									<el-popover placement="top-start" title trigger="hover">
										<img :src="'https://www.yizhi1996.com//patrolRecord//' + item" alt style="width: 250px; height: auto" />
										<img slot="reference" :src="'https://www.yizhi1996.com//patrolRecord//' + item" style="width: 70px; height: 70px; margin: 0 5px"
										 @click="imgClick(index)" />
									</el-popover>
								</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" :center='true' :append-to-body='true' center>
			<div style='width:100;text-align:center;'><img style="width: 100%; height: 600px;" :src='imgSrc'></div>
		</el-dialog>
	</div>

</template>

<script>
	import "@/assets/css/alarm/list.css";
	import CommonJs from "@/assets/js/common/common.js";
	import Maintenance from "@/assets/js/maintenance/maintenance.js";
	import Page from "@/components/common/page";
	export default {
		name: "alarm",
		components: {
			Page,
		},
		data() {
			return {
				imgSrc:'',
				dialogVisible: false,
				props: {
					checkStrictly: true,
					lazy: true,
					value: "areaCode",
					label: "name",
					lazyLoad(node, resolve) {
						var param = {};
						param.level = node.level;
						param.areaCode = node.value;
						CommonJs.getAreaList(param).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								data.data.forEach(function(item, index) {
									if (item.level < 4) {
										item.leaf = false;
									} else {
										item.leaf = true;
									}
								});
								resolve(data.data);
							}
						});
						// 通过调用resolve将子节点数据返回，通知组件数据加载完成
					},
				},
				searchParam: {
					customerName: "",
					areaCode: "",
					state: "",
					begintime: "",
					begintime2: "",
					customerType: "",
					contentTitle: "",
					contentDescribe: "",
				},
				sheet: [{
					title: "维护管理",
					tHeader: [
						"客户名称",
						"所在区域地址",
						"设备号",
						"维护开始时间",
						"完成时间",
						"人员",
						"维护类型",
						// "维护内容",
						"维护状态",
						"未及时维护",
					],
					keys: [
						"customerName",
						"address",
						"deviceId",
						"planDateBegin",
						"completionTime",
						"supportPerson",
						"contentTitle",
						// "contentDescribe",
						"stateName",
						"timeSection",
					],
					table: [],
					sheetName: "维护管理",
					cellStyle: [{
						cell: "A1",
						font: {
							name: "黑体",
							sz: "18px",
						},
					}, ],
				}, ],
				customerTypeList: [],
				stateList: [],
				typeList: [],
				contentList: [],
				menuList: [],
				tableData: [],
				pageCount: 20,
				pageSize: 10,
				pageNo: 1,
				height: 0,
				details: false,
				detail: {},

			};
		},
		methods: {
			imgClick(imgSrc) {
				this.imgSrc = 'https://www.yizhi1996.com//patrolRecord//' + this.detail.workPics[imgSrc];
				this.dialogVisible = true;
			},

			handleCurrentChange(val) {
				if (val == null) {
					return;
				}
				this.detail={};
				var param={}
				param.id=val.planId
				Maintenance.getmaintenanceById(param).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.detail=data.data[0];
						for(var i=0;this.stateList.length;i++){
							if(this.detail.state==this.stateList[i].id){
								this.detail.state=this.stateList[i].name
								break;
							}
						}
						var Y =new Date(this.detail.completionTime).getFullYear()
						var M =new Date(this.detail.completionTime).getMonth()<10?'0'+new Date(this.detail.completionTime).getMonth():new Date(this.detail.completionTime).getMonth()
						var D =new Date(this.detail.completionTime).getDay()<10?'0'+new Date(this.detail.completionTime).getDay():new Date(this.detail.completionTime).getDay()
						var h =new Date(this.detail.completionTime).getHours()<10?'0'+new Date(this.detail.completionTime).getHours():new Date(this.detail.completionTime).getHours()
						var m =new Date(this.detail.completionTime).getMinutes()<10?'0'+new Date(this.detail.completionTime).getMinutes():new Date(this.detail.completionTime).getMinutes()
						var s =new Date(this.detail.completionTime).getSeconds()<10?'0'+new Date(this.detail.completionTime).getSeconds():new Date(this.detail.completionTime).getSeconds()
						this.detail.completionTime=Y+'-'+M+'-'+D+' '+h+':'+m+':'+s
						if (this.detail.workPics != null && this.detail.workPics != '') {
							this.detail.workPics = this.detail.workPics.split(",");
						}

					}
				})
				.catch((response) => {});
			},
			showDetails() {

				if (Object.keys(this.detail).length > 0) {
					this.details = true;
					console.log(this.detail)
				} else {
					this.utils.tipsAlert("请选择数据");
				}
			},
			getIndex(index) {
				return (this.pageNo - 1) * this.pageSize + index + 1;
			},
			queryArea(item) {
				let param = {
					pageNo: 1,
					pageSize: this.pageSize,
				};
				if (item == "all") {
					this.$delete(this.searchParam, "city");
					this.$delete(this.searchParam, "district");
					this.search(param);
				} else {
					this.$delete(this.searchParam, "city");
					this.$delete(this.searchParam, "district");
					Object.assign(this.searchParam, item);
					this.search(param);
				}
			},
			async getCustomerTypeList() {
				CommonJs.getDict("客户类型")
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							let list = [];
							data.data.forEach(function(item, index) {
								var param = {};
								param.id = item.rank;
								param.name = item.value;
								list.push(param);
							});
							this.customerTypeList = list;
						}
					})
					.catch((response) => {});
			},
			async getStateList() {
				CommonJs.getDict("维护状态")
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							let list = [];
							data.data.forEach(function(item, index) {
								var param = {};
								param.id = item.rank;
								param.name = item.value;
								list.push(param);
							});
							// console.log(list);
							this.stateList = list;
						}
					})
					.catch((response) => {});
			},
			async getTypeList() {
				CommonJs.getDict("维护类型")
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							let list = [];
							data.data.forEach(function(item, index) {
								var param = {};
								param.id = item.rank;
								param.name = item.value;
								list.push(param);
							});
							this.typeList = list;
						}
					})
					.catch((response) => {});
			},
			async getContentList() {
				CommonJs.getDict("维护内容")
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							let list = [];
							data.data.forEach(function(item, index) {
								var param = {};
								param.id = item.rank;
								param.name = item.value;
								list.push(param);
							});
							this.contentList = list;
						}
					})
					.catch((response) => {});
			},
			search(param) {
				if (this.searchParam.customerName != "") {
					param.customerName = this.searchParam.customerName;
				}
				if (this.searchParam.state !== "") {
					param.state = this.searchParam.state;
				}
				if (
					this.searchParam.begintime != "" &&
					this.searchParam.begintime != null &&
					this.searchParam.begintime2 != "" &&
					this.searchParam.begintime2 != null
				) {
					param.begintime = this.searchParam.begintime;
					param.begintime2 = this.searchParam.begintime2;
				} else {
					if (
						(this.searchParam.begintime != "" &&
							this.searchParam.begintime != null) ||
						(this.searchParam.begintime2 != "" &&
							this.searchParam.begintime2 != null)
					) {
						this.utils.tipsAlert("请选择维护日期开始与结束日期");
					}
				}
				if (this.searchParam.customerType !== "") {
					param.customerType = this.searchParam.customerType;
				}
				if (this.searchParam.contentTitle !== "") {
					param.contentTitle = this.searchParam.contentTitle;
				}
				if (this.searchParam.contentDescribe !== "") {
					param.contentDescribe = this.searchParam.contentDescribe;
				}
				if (this.searchParam.city !== "") {
					param.city = this.searchParam.city;
				}
				if (this.searchParam.district !== "") {
					param.district = this.searchParam.district;
				}
				if (param.city == 'all') {
					param.city = null;
				}
				this.post(param);
				this.getExcelList(param);
			},
			getNowTime(time) {
				var now = time;
				var year = now.getFullYear(); //得到年份
				var month = now.getMonth(); //得到月份
				var date = now.getDate(); //得到日期
				month = month + 1;
				month = month.toString().padStart(2, "0");
				date = date.toString().padStart(2, "0");
				var defaultDate = `${year}-${month}-${date}`;
				return defaultDate;
			},
			getExcelList(param) {
				Maintenance.getExcel(param)
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							var list = [];
							var $this = this;
							data.data.forEach(function(item, index) {
								var newItem = item;
								newItem.customerName =
									item.customerName == null ? " " : item.customerName;
								newItem.address = item.address == null ? " " : item.address;
								newItem.completionTime =
									item.completionTime == null ? " " : item.completionTime;
								newItem.supportPerson =
									item.supportPerson == null ? " " : item.supportPerson;
								newItem.contentTitle =
									item.contentTitle == null ? " " : item.contentTitle;
								newItem.contentDescribe =
									item.contentDescrib == null ? " " : item.contentDescrib;
								$this.stateList.forEach(function(item1, index1) {
									if (item.state === item1.id + "") {
										newItem.stateName = item1.name;
									}
								});
								newItem.timeSection = $this.getTimeSection(
									item.receiveTime,
									item.completionTime
								);
								list.push(newItem);
							});
							this.sheet[0].table = list;
							console.log(list);
						}
					})
					.catch((response) => {});
			},
			post(param) {
				Maintenance.getList(param)
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							this.pageCount = data.data.total;
							this.pageNo = data.data.current;
							this.$refs["pageModel"].setCurrent(this.pageNo);
							this.tableData = data.data.records;
						}
					})
					.catch((response) => {});
			},
			getTimeSection(startTime, endTime) {
				let res = "未处理";
				if (startTime != null && endTime != null) {
					let timeSection =
						this.getTimeString(endTime) - this.getTimeString(startTime);
					let getDay = parseInt(timeSection / 1000 / 60 / 60 / 24);
					if (getDay > 3) {
						res = "未及时维护";
					}
					if (getDay <= 3) {
						res = "及时维护";
					}
				} else {
					res = "未处理";
				}
				return res;
			},
			getTimeString(time) {
				let timeString = new Date(time).getTime();
				return timeString;
			},
		},
		created() {
			this.searchParam.begintime2 = this.getNowTime(new Date());
			this.searchParam.begintime = this.getNowTime(
				new Date(new Date().setMonth(new Date().getMonth() - 1))
			);
			this.getCustomerTypeList();
			this.getStateList();
			this.getTypeList();
			this.getContentList();
			this.search({
				pageNo: 1,
				pageSize: 10,
			});
			this.timer = setTimeout(() => {
				this.height = this.$refs.multipleTable.clientHeight - 5;
			}, 200);
			window.onresize = () => {
				this.height = this.$refs.multipleTable.clientHeight - 5;
			};
			this.menuList = this.$store.getters.getMenuPermission;
			/* if (sessionStorage.getItem('store')) {
			    this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
			  } */
		},
	};
</script>
<style>
	.searchBox-condition .date-class.el-date-editor.el-input {
		height: 30px;
	}

	.searchBox-condition .date-class .el-input__inner {
		border: 0;
		background-color: #f5f5f5;
		height: 30px;
		border-radius: 15px;
	}

	.searchBox-condition .date-class .el-range-input {
		background-color: #f5f5f5;
	}

	.searchBox-condition .date-class .el-input__icon {
		line-height: 3.5;
	}

	.searchBox-condition .select-class .el-input__icon {
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/list.vue